import { Table as ChakraTable, Box } from '@chakra-ui/react';
import { useMultiStyleConfig, forwardRef } from '@chakra-ui/system';
import { mergeWith } from '@chakra-ui/utils';
import React from 'react';

import TableBody from './TableBody';
import { useTableExperimentalContext } from './TableExperimentalContext';
import TableHeader from './TableHeader';
import TablePagination from './TablePagination';
import { TableProps } from './TableTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TableExperimentalProps = TableProps<any>;

const TableSelf = forwardRef(
  (): React.ReactElement => {
    const { ref, isScrollLeftEdge, onRowClick, pagination, tableSelfProps } = useTableExperimentalContext();
    const { disableRowHoverStyle, isStickyHeader, isStickyFirstColumn, sx, tdCheckboxSx, ...rest } = tableSelfProps;

    const themeStyles = useMultiStyleConfig('TableExperimental', {
      disableRowHoverStyle,
      isStickyHeader,
      isStickyFirstColumn,
      isScrollLeftEdge,
      onRowClick,
      pagination
    });

    return (
      <Box {...rest} __css={themeStyles.tableContainer} ref={ref} sx={mergeWith(themeStyles, sx)}>
        <ChakraTable>
          <TableHeader />
          <TableBody tdCheckboxSx={tdCheckboxSx} />
        </ChakraTable>
        {pagination && <TablePagination />}
      </Box>
    );
  }
);

TableSelf.displayName = 'TableSelf';
TableSelf.defaultProps = {};

export default TableSelf;
